module.exports = __webpack_public_path__ + "img/Hero-banner.426c699b.png";